/* Display only: account for the Shopify preview toolbar. */
(function () {
  var root = document.querySelector('[data-requirements-planner]');
  if (!root) return;
  root.classList.toggle('rq-preview-mode', !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'unpublished'));
  var purchaseBar = root.querySelector('.rq-save-actions');
  if (purchaseBar && window.ResizeObserver) {
    new ResizeObserver(function () {
      var height = purchaseBar.getBoundingClientRect().height;
      if (height) document.documentElement.style.setProperty('--advisor-checkout-height', height + 'px');
    }).observe(purchaseBar);
  }
})();
